// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_Doh","cls2":"Playlist-cls2_wyK Playlist-cls1_Doh"};